import { Box } from "@mui/material";
import React from "react";

const Wrapper: React.FC = ({ children }) => (
  <Box maxWidth={1280}>{children}</Box>
);

export default Wrapper;
